<template>
  <k-field-group language-prefix="instruction">
    <v-container>
      <v-form ref="form" v-model="valid" class="mt-5">
        <v-row justify="center" style="min-width: 100%;">
          <v-col cols="12" lg="10">
            <v-subheader class="pa-0">{{ $tc('instruction.title', 1) }}</v-subheader>
            <v-card>
              <v-card-text>
                <ClientAutocomplete field="fields.clientName" v-model="values.clientId" :return-object="false"/>
                <KCheckbox v-model="values.isActive" field="fields.isActive"/>
                <KCheckbox v-model="values.isBillable" field="fields.isBillable"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" lg="5">
            <v-subheader class="pa-0">{{ $t('instruction.actions.title') }}</v-subheader>
            <v-card>
              <v-card-text>
                <IsBlockedSelect v-model="values.actions.block" field="actions.isBlocked"/>

                <KTextField field="actions.fields.orderType" v-model="values.actions.fields.orderType"/>
                <KTextField field="actions.fields.shippingMethod" v-model="values.actions.fields.shippingMethod"/>
                <KTextarea field="actions.fields.comment"
                           v-model="values.actions.fields.comment"
                           counter
                           :rows="3"
                           :validateOnBlur="false"
                           :rules="commentRules"/>
                <KTextarea field="actions.fields.complimentCardText"
                           v-model="values.actions.fields.complimentCardText"
                           counter
                           :rows="5"
                           :validateOnBlur="false"
                           :rules="complimentCardTextRules"/>
                <KTextField field="actions.fields.vatNumber" v-model="values.actions.fields.vatNumber"/>
                <KTextField field="actions.fields.termsOfDelivery" v-model="values.actions.fields.termsOfDelivery"/>
                <KTextField field="actions.fields.webshopSourceId" v-model="values.actions.fields.webshopSourceId"/>
                <KTextField field="actions.fields.customerReference" v-model="values.actions.fields.customerReference"/>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="5">
            <v-subheader class="pa-0">{{ $t('instruction.conditions.deliveryAddress.title') }}</v-subheader>
            <v-card>
              <v-card-text>
                <KTextField field="conditions.deliveryAddress.companyName"
                            v-model="values.conditions.deliveryAddress.companyName"/>
                <KTextField field="conditions.deliveryAddress.department"
                            v-model="values.conditions.deliveryAddress.department"/>
                <KTextField field="conditions.deliveryAddress.firstName"
                            v-model="values.conditions.deliveryAddress.firstName"/>
                <KTextField field="conditions.deliveryAddress.lastName"
                            v-model="values.conditions.deliveryAddress.lastName"/>
                <KTextField field="conditions.deliveryAddress.street"
                            v-model="values.conditions.deliveryAddress.street"/>
                <KTextField field="conditions.deliveryAddress.houseNumber"
                            v-model="values.conditions.deliveryAddress.houseNumber"/>
                <KTextField field="conditions.deliveryAddress.houseNumberAddition"
                            v-model="values.conditions.deliveryAddress.houseNumberAddition"/>
                <KTextField field="conditions.deliveryAddress.postalCode"
                            v-model="values.conditions.deliveryAddress.postalCode"/>
                <KTextField field="conditions.deliveryAddress.city" v-model="values.conditions.deliveryAddress.city"/>
                <KTextField field="conditions.deliveryAddress.country"
                            v-model="values.conditions.deliveryAddress.country"/>
                <KTextField field="conditions.deliveryAddress.email" v-model="values.conditions.deliveryAddress.email"/>
                <KTextField field="conditions.source" v-model="values.conditions.source"/>
                <KTextField field="conditions.webshopSourceId" v-model="values.conditions.webshopSourceId"/>
                <KTextField field="conditions.shippingMethod" v-model="values.conditions.shippingMethod"/>
                <KTextField field="conditions.customerReference" v-model="values.conditions.customerReference"/>

                <v-row>
                  <v-col cols="5">
                    <KTextField field="conditions.minimumTotalLines" v-model="values.conditions.hasItems.minimumTotalLines"/>
                  </v-col>
                  <v-col cols="2">
                    <KSelect field="conditions.operator" v-model="values.conditions.hasItems.operator" :items="operators"/>
                  </v-col>
                  <v-col cols="5">
                    <KTextField field="conditions.minimumTotalQuantity" v-model="values.conditions.hasItems.minimumTotalQuantity"/>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </k-field-group>
</template>

<script lang="js">
import Instruction from '@/application/models/instruction.js';
import ClientAutocomplete from '@/components/autocompletes/Client.vue';
import KFieldGroup from '@/components/crud/fields/KFieldGroup.vue';
import Form from '@/components/VuetifyResourceBaseForm.vue';
import KCheckbox from '@/components/crud/fields/KCheckbox.vue';
import KTextField from '@/components/crud/fields/KTextField.vue';
import IsBlockedSelect from '@/components/selects/IsBlocked.vue';
import KTextarea from '@/components/crud/fields/KTextarea.vue';
import KSelect from "@/components/crud/fields/KSelect.vue";

const operators = [
  {
    text: 'en',
    value: 'AND'
  },
  {
    text: 'of',
    value: 'OR'
  }
]

export default {
  name: 'InstructionForm',
  extends: Form,
  components: {
    KSelect,
    KTextarea,
    IsBlockedSelect,
    KTextField,
    KCheckbox,
    ClientAutocomplete,
    KFieldGroup,
  },
  data: () => ({
    values: new Instruction(),
    operators
  }),
  computed: {
    commentRules() {
      return [v => typeof (v) === 'undefined' || v.length <= 200 || this.$t('validation.maxCharacters', { maxChar: 200 })];
    },
    complimentCardTextRules() {
      return [v => typeof (v) === 'undefined' || v.length <= 350 || this.$t('validation.maxCharacters', { maxChar: 350 })];
    },
  },
};
</script>
